<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import AuthentificationLayout from "./AuthentificationLayout";
import DefaultLayout from "./DefaultLayout";
import EmptyLayout from "./EmptyLayout";
import ConfirmationLayout from "./ConfirmationLayout";

export default {
  computed: {
    layout() {
      if (this.$route.meta.layout === "AuthentificationLayout") {
        return AuthentificationLayout;
      } else if (this.$route.meta.layout === "DefaultLayout") {
        return DefaultLayout;
      } else if (this.$route.meta.layout === "ConfirmationLayout") {
        return ConfirmationLayout;
      } else {
        return EmptyLayout;
      }
    },
  },
};
</script>
